__turbopack_context__.v({
  "imageContainer": "styles-module-scss-module__FYo0Mq__imageContainer",
  "pageHero": "styles-module-scss-module__FYo0Mq__pageHero",
  "text": "styles-module-scss-module__FYo0Mq__text",
  "textContainer": "styles-module-scss-module__FYo0Mq__textContainer",
});
